// Arabisch (ar), homeApp: zelfde vorm als homeApp.nl.ts (golf 6b). Meervoud met zero/one/two/few/
// many/other zoals app.ar.ts. In een rechts-naar-links-scherm wisselen de pijltjes ← en → van
// betekenis niet: ← blijft "vorige" (de sneltoets volgt de toetsen, niet de leesrichting).
export const appHomeAr = {
    customize: 'تخصيص',
    customizeLabel: 'تخصيص شاشة اليوم',
    done: 'تم',
    intro: 'ضع في شاشة اليوم ما يهمك. اسحب البطاقة إلى مكان آخر، وكبّرها أو صغّرها من حافتها أو زاويتها، أو اختر S أو M أو L.',
    /** Telefoon: alleen de volgorde (feat/vandaag-raster). */
    introList: 'رتّب البطاقات كما تريد: اسحبها من مقبضها أو استخدم الأسهم. على شاشة أكبر يمكنك أيضًا وضعها حيث تشاء وتكبيرها أو تصغيرها.',
    undo: 'تراجع',
    undone: 'تم التراجع عن آخر تغيير.',
    /** Raster (computer en tablet): zoals de bord-editor. */
    gridHint: 'شبكة شاشة اليوم: اسحب البطاقة إلى مكان آخر، واسحب حافتها أو زاويتها لتصغيرها أو تكبيرها.',
    cardAt: '{name}، {w} × {h} خانات، العمود {x}، الصف {y}',
    keysHint: 'الأسهم: نقل. Shift مع الأسهم: تصغير أو تكبير.',
    noRoom: 'لا تتسع هنا. صغّر شيئًا أو أزله أولًا.',
    size: 'الحجم',
    sizes: { S: 'صغير', M: 'متوسط', L: 'كبير' },
    fitMore: '+{count} أخرى',
    fitMoreAll: 'عرض المزيد',
    reset: 'استعادة الترتيب الافتراضي',
    resetDone: 'عادت شاشة اليوم كما كانت.',
    saveFailed: 'لم ينجح الحفظ. حاول مرة أخرى بعد قليل.',
    add: 'إضافة بطاقة',
    addTitle: 'إضافة بطاقة',
    addNothing: 'كل البطاقات موجودة بالفعل.',
    moveUp: 'نقل {name} إلى الأعلى',
    moveDown: 'نقل {name} إلى الأسفل',
    remove: 'إزالة {name}',
    removed: 'تمت إزالة {name}.',
    added: '{name} الآن في شاشة اليوم.',
    drag: 'سحب {name}',
    position: '{name} الآن في المكان {pos} من {count}.',
    empty: 'شاشة اليوم فارغة بعد.',
    emptyBody: 'اضغط على تخصيص واختر ما تريد رؤيته هنا.',
    emptyEdit: 'لا توجد بطاقات بعد. أضف واحدة في الأسفل.',
    quiet: 'لا شيء لعرضه الآن. تظهر البطاقة من تلقاء نفسها عندما يكون هناك شيء.',
    widgets: {
        now: { name: 'يجري الآن', description: 'ما يحدث الآن أو يبدأ قريبًا' },
        agenda: { name: 'أجندة اليوم', description: 'كل مواعيد اليوم' },
        tasks: { name: 'مهام اليوم', description: 'إلى أين وصل كل واحد في مهامه' },
        tomorrow: { name: 'غدًا', description: 'نظرة على مواعيد الغد' },
        weather: { name: 'الطقس', description: 'الطقس ونصيحة اللباس، اضغط للمزيد' },
        rides: { name: 'التوصيلات', description: 'توصيلات لم يتكفل بها أحد بعد' },
        prayer: { name: 'مواقيت الصلاة', description: 'مواقيت اليوم' },
        check_in: { name: 'التحقق اليومي', description: 'هل وصل «كل شيء بخير» اليوم' },
        goals: { name: 'الادخار', description: 'إلى أين وصل الأطفال في الادخار' },
        shopping: { name: 'المشتريات', description: 'ما زال يجب شراؤه' },
        messages: { name: 'الرسائل', description: 'رسائل جديدة من العائلة' },
        wishes: { name: 'الأمنيات', description: 'أمنيات الأطفال' },
        rotation: { name: 'جدول المناوبة', description: 'من يفعل ماذا هذا الأسبوع ومن يطبخ اليوم' },
        // Golf 8 (0049): Samen wonen.
        dinner: { name: 'عشاء الليلة', description: 'من سيأكل معنا واختيارك' },
        bookings: { name: 'الحجوزات', description: 'حجزك التالي وما هو متاح' },
        balance: { name: 'التكاليف', description: 'رصيدك أنت فقط' },
        // 0069: Geldzaken (alleen in je eigen omgeving).
        money: { name: 'الشؤون المالية', description: 'ما تبقّى هذا الشهر (أنت فقط)' },
        todos: { name: 'مهام لاحقة', description: 'مهامك اللاحقة المفتوحة مع آخر موعد' },
        // 0076: schoolplanner.
        school: {
            name: 'الواجبات والاختبارات',
            description: 'واجبات اليوم والاختبارات القادمة والدرجات المطلوب إدخالها',
        },
        // 0075: Huisronde (module Eten).
        house_round: { name: 'جولة المنزل', description: 'الجولة القادمة في المنزل، وابدأها' },
    },
    shopping: {
        open: {
            zero: 'لا شيء للشراء',
            one: 'شيء واحد للشراء',
            two: 'شيئان للشراء',
            few: '{count} أشياء للشراء',
            many: '{count} شيئًا للشراء',
            other: '{count} شيء للشراء',
        },
        empty: 'اشتُري كل شيء.',
        all: 'إلى المشتريات',
        more: '+{count} أخرى',
    },
    messages: {
        unread: {
            zero: 'لا رسائل جديدة',
            one: 'رسالة جديدة واحدة',
            two: 'رسالتان جديدتان',
            few: '{count} رسائل جديدة',
            many: '{count} رسالة جديدة',
            other: '{count} رسالة جديدة',
        },
        none: 'لا رسائل جديدة.',
        all: 'إلى الرسائل',
        voice: 'رسالة صوتية',
        sticker: 'ملصق',
        pictos: 'صور',
    },
    wishes: {
        count: {
            zero: 'لا أمنيات',
            one: 'أمنية واحدة',
            two: 'أمنيتان',
            few: '{count} أمنيات',
            many: '{count} أمنية',
            other: '{count} أمنية',
        },
        empty: 'لا أمنيات بعد.',
        all: 'إلى الأمنيات',
    },
    /** Golf 6b fixer r1: widget Beurtrooster (huisgenoten). */
    rotation: {
        you: 'أنت هذا الأسبوع',
        done: 'تم',
        open: 'لم يُنجز بعد',
        noneForYou: 'ليس لديك دور هذا الأسبوع.',
        cooks: '{name} يطبخ اليوم',
        youCook: 'أنت تطبخ اليوم',
        others: 'بقية البيت',
        all: 'إلى جدول المناوبة',
        empty: 'لا يوجد جدول مناوبة بعد.',
    },
    prayer: {
        next: 'التالية',
        settings: 'الإعدادات',
        fromTable: 'من جدول مسجدك',
    },
};
export const appAgendaViewsAr = {
    day: 'يوم',
    workweek: 'أسبوع العمل',
    week: 'أسبوع',
    month: 'شهر',
    workweekTitle: 'أسبوع العمل {week} · {range}',
    emptyWorkweek: 'لا شيء مخطط له في أسبوع العمل هذا بعد',
    prev: {
        day: 'اليوم السابق',
        workweek: 'أسبوع العمل السابق',
        week: 'الأسبوع السابق',
        month: 'الشهر السابق',
    },
    next: {
        day: 'اليوم التالي',
        workweek: 'أسبوع العمل التالي',
        week: 'الأسبوع التالي',
        month: 'الشهر التالي',
    },
    keys: 'اختصارات: ← و → للتنقل، و T لليوم.',
};
export const appWeatherDetailAr = {
    open: 'المزيد عن الطقس',
    titleToday: 'الطقس اليوم',
    titleTomorrow: 'الطقس غدًا',
    today: 'اليوم',
    tomorrow: 'غدًا',
    temp: 'درجة الحرارة',
    tempRange: 'من {min}° إلى {max}°',
    feels: 'الحرارة المحسوسة',
    feelsRange: 'من {min}° إلى {max}°',
    feelsDay: 'نحو {value}° أثناء النهار',
    rain: 'المطر',
    rainChance: {
        dry: 'جاف',
        small: 'احتمال ضعيف لزخة مطر',
        likely: 'احتمال مطر',
        wet: 'ممطر',
    },
    rainAmount: '{mm} مم',
    rainHours: {
        zero: 'في أقل من ساعة',
        one: 'في ساعة واحدة',
        two: 'في ساعتين',
        few: 'في {count} ساعات',
        many: 'في {count} ساعة',
        other: 'في {count} ساعة',
    },
    rainWhen: 'بين {from} و{until}',
    rainPct: 'احتمال {pct}%',
    rainNoPct: 'لا تعطي MET Norway احتمالًا بالنسبة المئوية لهولندا. هذه كمية المطر المتوقعة حسب التنبؤ.',
    wind: 'الرياح',
    windForce: 'قوة الرياح {bft}',
    windFrom: 'من {dir}',
    windSpeed: '{kmh} كم/س',
    bft: [
        'سكون',
        'هواء خفيف',
        'نسيم خفيف',
        'نسيم لطيف',
        'نسيم معتدل',
        'نسيم منعش',
        'رياح قوية',
        'رياح شديدة',
        'عاصفة',
        'عاصفة قوية',
        'عاصفة شديدة',
        'عاصفة عنيفة',
        'إعصار',
    ],
    dirs: {
        N: 'الشمال',
        NE: 'الشمال الشرقي',
        E: 'الشرق',
        SE: 'الجنوب الشرقي',
        S: 'الجنوب',
        SW: 'الجنوب الغربي',
        W: 'الغرب',
        NW: 'الشمال الغربي',
    },
    dirShort: { N: 'ش', NE: 'ش ق', E: 'ق', SE: 'ج ق', S: 'ج', SW: 'ج غ', W: 'غ', NW: 'ش غ' },
    uv: 'قوة الشمس',
    uvLevels: {
        low: 'منخفضة',
        moderate: 'متوسطة',
        high: 'مرتفعة',
        very_high: 'مرتفعة جدًا',
        extreme: 'شديدة جدًا',
    },
    uvValue: 'UV {value}، {level}',
    uvClearSky: 'في سماء صافية',
    sun: 'الشمس',
    sunrise: 'الشروق {time}',
    sunset: 'الغروب {time}',
    course: 'على مدار اليوم',
    courseOpen: 'ساعة بساعة',
    back: 'رجوع',
    courseTemp: 'درجة الحرارة (°م)',
    courseRain: 'الأمطار (مم في الساعة)',
    courseHour: '{time}: {temp}°، {rain} مم، قوة الرياح {bft}',
    partial: 'لم تُعرف كل ساعات هذا اليوم بعد.',
    now: 'الآن',
    close: 'إغلاق',
    symbols: {
        clear: 'مشمس',
        partly_cloudy: 'غائم جزئيًا',
        cloudy: 'غائم',
        fog: 'ضباب',
        drizzle: 'رذاذ',
        rain: 'مطر',
        heavy_rain: 'مطر غزير',
        sleet: 'مطر ثلجي',
        snow: 'ثلج',
        thunder: 'رعد',
    },
};
//# sourceMappingURL=homeApp.ar.js.map